import {
  REQUEST_PROFILE_HEADER_INFO_DWELLER_ITEMS_COUNT,
  REQUEST_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW,
  REQUEST_PROFILE_HEADER_INFO_ITEMS_MIN_ITEMS_IN_ROW,
} from './RequestProfileHeaderInfoItems.constants'

export function isRequestProfileHeaderInfoItemsBuildingSpanning(columnsCount) {
  return columnsCount === REQUEST_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW
}

export function getRequestProfileHeaderInfoItemsColumnsCount(items) {
  return items?.length === REQUEST_PROFILE_HEADER_INFO_DWELLER_ITEMS_COUNT
    ? REQUEST_PROFILE_HEADER_INFO_ITEMS_MIN_ITEMS_IN_ROW
    : REQUEST_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW
}
